module.exports = __webpack_public_path__ + "img/suone_1.693fbe44.jpg";